import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsRulesPreferences({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M6 8a1 1 0 011 1v3.8a1 1 0 01-1 1H2.2a1 1 0 01-1-1V9a1 1 0 011-1H6zm0-6.8a1 1 0 011 1V6a1 1 0 01-1 1H2.2a1 1 0 01-1-1V2.2a1 1 0 011-1H6zm6.8 0a1 1 0 011 1V6a1 1 0 01-1 1H9a1 1 0 01-1-1V2.2a1 1 0 011-1h3.8zM12 16a4 4 0 100-8 4 4 0 000 8zm2.29-3.42l-.42-.24c.04-.23.04-.46 0-.68l.42-.24a.12.12 0 00.05-.13 2.4 2.4 0 00-.54-.92.12.12 0 00-.14-.02l-.43.24a1.88 1.88 0 00-.6-.34v-.48c0-.05-.04-.1-.1-.11a2.54 2.54 0 00-1.07 0 .12.12 0 00-.1.11v.48a1.9 1.9 0 00-.6.34l-.42-.24a.12.12 0 00-.14.02c-.25.26-.43.57-.54.92-.02.05 0 .1.05.13l.42.24c-.04.22-.04.46 0 .68l-.42.24a.12.12 0 00-.05.13c.1.35.3.66.54.92.03.04.1.05.14.02l.42-.24c.18.15.39.27.6.34v.48c0 .05.05.1.1.11.36.08.74.08 1.08 0 .05-.01.1-.06.1-.11v-.48c.21-.07.42-.19.6-.34l.42.24c.05.03.1.02.14-.02.25-.26.43-.57.54-.92.02-.05 0-.1-.05-.13zm-2.3.2a.78.78 0 01-.78-.78c0-.43.35-.78.79-.78.44 0 .8.35.8.78 0 .43-.36.77-.8.77z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsRulesPreferences.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsRulesPreferences.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsRulesPreferences svgRef={ref} {...props} />
));
export default ForwardRef;
